import React from 'react';
import { Instagram, Twitter, Youtube, Mail, MapPin, Calendar } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { icon: Instagram, href: "https://instagram.com/BrownishhOfficial", label: "Instagram" },
    { icon: Twitter, href: "https://twitter.com/BrownishhOfficial", label: "Twitter" },
    { icon: Youtube, href: "https://youtube.com/BrownishhOfficial", label: "YouTube" }
  ];

  const upcomingEvents = [
    {
      name: "#Brownishh Pop-Up NYC",
      date: "March 15, 2024",
      location: "Brooklyn, NY"
    },
    {
      name: "Cultural Pride Summit",
      date: "April 20, 2024", 
      location: "Los Angeles, CA"
    }
  ];

  const handleShopClick = () => {
    window.open('https://shop.brownishh.com', '_blank');
  };

  return (
    <footer className="bg-richBrown text-warmCream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
            {/* Brand Section */}
            <div className="lg:col-span-2">
              <h3 className="text-3xl font-black text-goldAccent mb-4 tracking-tight">
                #Brownishh
              </h3>
              <p className="text-warmCream/80 leading-relaxed mb-4 max-w-md">
                Bold, brown, and unbothered. We're not waiting for permission. We are the standard.
              </p>
              
              <p className="text-goldAccent font-bold mb-6">
                Founded by Brianna Marie - Creative Latina building a movement.
              </p>
              
              {/* Social Links */}
              <div className="flex items-center gap-4">
                <span className="text-sm font-medium">Follow the movement:</span>
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-warmBrown hover:bg-goldAccent text-warmCream hover:text-richBrown rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                    aria-label={social.label}
                  >
                    <social.icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-bold text-goldAccent mb-4 tracking-wide">THE MOVEMENT</h4>
              <ul className="space-y-2">
                <li>
                  <button 
                    onClick={handleShopClick}
                    className="text-warmCream/80 hover:text-goldAccent transition-colors duration-200 text-left"
                  >
                    #Brownishh Collection
                  </button>
                </li>
                <li>
                  <button 
                    onClick={handleShopClick}
                    className="text-warmCream/80 hover:text-goldAccent transition-colors duration-200 text-left"
                  >
                    New Arrivals
                  </button>
                </li>
                <li><a href="#" className="text-warmCream/80 hover:text-goldAccent transition-colors duration-200">Media Platform (Coming Soon)</a></li>
                <li><a href="#" className="text-warmCream/80 hover:text-goldAccent transition-colors duration-200">Cultural Stories</a></li>
                <li>
                  <button 
                    onClick={handleShopClick}
                    className="text-warmCream/80 hover:text-goldAccent transition-colors duration-200 text-left"
                  >
                    Lookbook
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact & Events */}
            <div>
              <h4 className="text-lg font-bold text-goldAccent mb-4 tracking-wide">CONNECT</h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <Mail className="w-5 h-5 text-goldAccent mt-0.5 flex-shrink-0" />
                  <div>
                    <div className="text-sm text-warmCream/60 mb-1">Email us:</div>
                    <a href="mailto:hello@brownishh.com" className="text-warmCream hover:text-goldAccent transition-colors duration-200">
                      hello@brownishh.com
                    </a>
                  </div>
                </div>
                
                <div>
                  <div className="flex items-center gap-2 mb-3">
                    <Calendar className="w-5 h-5 text-goldAccent" />
                    <span className="text-sm font-medium text-goldAccent">UPCOMING EVENTS</span>
                  </div>
                  <div className="space-y-3">
                    {upcomingEvents.map((event, index) => (
                      <div key={index} className="text-sm">
                        <div className="font-medium text-warmCream">{event.name}</div>
                        <div className="text-warmCream/60 flex items-center gap-2">
                          <span>{event.date}</span>
                          <span>•</span>
                          <span className="flex items-center gap-1">
                            <MapPin className="w-3 h-3" />
                            {event.location}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-warmBrown py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-warmCream/60">
              © 2024 #Brownishh. All rights reserved. Stay brown. Stay bold.
            </div>
            
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-warmCream/60 hover:text-goldAccent transition-colors duration-200">Privacy Policy</a>
              <a href="#" className="text-warmCream/60 hover:text-goldAccent transition-colors duration-200">Terms of Service</a>
              <a href="#" className="text-warmCream/60 hover:text-goldAccent transition-colors duration-200">Shipping & Returns</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;